class UtilsService {
  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      return {
        success: true,
        message: 'Texto copiado al portapapeles'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al copiar al portapapeles'
      };
    }
  }

  downloadFile(url, filename) {
    try {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return {
        success: true,
        message: 'Archivo descargado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al descargar el archivo'
      };
    }
  }

  downloadQRImage(qrCodeImage, eventTitle) {
    const safeTitle = eventTitle || 'Evento';
    const filename = `QR-${safeTitle.replace(/[^a-zA-Z0-9]/g, '_')}.png`;
    return this.downloadFile(qrCodeImage, filename);
  }

  showAlert(message, type = 'info') {
    // Función para mostrar alertas (puede ser expandida con toast notifications)
    if (type === 'success') {
      alert(`✅ ${message}`);
    } else if (type === 'error') {
      alert(`❌ ${message}`);
    } else {
      alert(`ℹ️ ${message}`);
    }
  }

  sanitizeFilename(filename) {
    return filename.replace(/[^a-zA-Z0-9]/g, '_');
  }

  formatEventTitle(title) {
    return title || 'Sin título';
  }

  generateUniqueId() {
    return Math.random().toString(36).substring(2, 15) + 
           Math.random().toString(36).substring(2, 15) + 
           Date.now().toString(36);
  }
}

export default new UtilsService();